import { useState, useEffect } from 'react';
import Navigation from '../../../components/feature/Navigation';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleReserveClick = () => {
    const calculatorSection = document.getElementById('prijzen');
    if (calculatorSection) {
      calculatorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <Navigation isScrolled={isScrolled} />
      
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/541480def69250fdca691bb15a21e7c3.jpg')] bg-cover bg-center"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center py-20">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Betrouwbare Airport Taxi<br />Utrecht & Omgeving
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-slate-200 mb-12 max-w-3xl mx-auto leading-relaxed">
            Vaste all-in prijzen naar Schiphol, Rotterdam en Eindhoven Airport.<br />
            Geen verborgen kosten. 24/7 beschikbaar.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={handleReserveClick}
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-amber-500 text-white text-base sm:text-lg font-bold rounded-lg hover:bg-amber-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>Reserveer Nu & Zie Prijs
            </button>
            <a
              href="tel:+31658824429"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-white text-slate-900 text-base sm:text-lg font-bold rounded-lg hover:bg-slate-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>Bel Direct
            </a>
            <a
              href="https://wa.me/31658824429"
              className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-green-500 text-white text-base sm:text-lg font-bold rounded-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>WhatsApp Reserveren
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-green-400 text-xl"></i>
              <span className="text-sm md:text-base">24/7 Beschikbaar</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-green-400 text-xl"></i>
              <span className="text-sm md:text-base">Vaste Prijs Mogelijk</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-green-400 text-xl"></i>
              <span className="text-sm md:text-base">Professionele Chauffeurs</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
